import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';

const useRAIIdsByImageId = (imageId: string | undefined, authorId: string | undefined, userId: string | undefined): string[] => {
  const RAIDb = useSelector((state: RootState) => state.relationAlbumImageDb);
  const RUADb = useSelector((state: RootState) => state.relationUserAlbumDb);
  let ids: string[] = [];

  if (authorId === userId) { //カレントユーザが指定画像のオーナーの場合
    ids = Object.keys(RAIDb.relationAlbumImages).filter(id => RAIDb.relationAlbumImages[id].imageId === imageId);
  }
  else { //カレントユーザが指定画像のオーナーではない場合
    //カレントユーザに紐付いているアルバム内の指定画像レコードを抽出する
    const rua_ids = Object.keys(RUADb.relationUserAlbums).filter(id => RUADb.relationUserAlbums[id].userId === userId);
    rua_ids.forEach(rua_id => {
      ids.push(...Object.keys(RAIDb.relationAlbumImages).filter(id =>
        (RAIDb.relationAlbumImages[id].imageId === imageId) &&
        (RAIDb.relationAlbumImages[id].albumId === RUADb.relationUserAlbums[rua_id].albumId)));
    });
  }

  return ids;
}

export default useRAIIdsByImageId;
